import cn from 'classnames';
import PropTypes from 'prop-types';

function LdsLoadingSpinner({
  size = 40,
  animationSpeed = 1000,
  decorative = false,
  ariaLabel = 'loading',
  svgTitle = 'loading',
  className = '',
  ...rest
}) {
  const dimSize = `${size}px`;
  const durAnimationSpeed = `${animationSpeed}ms`;
  const txtAriaLabel = ariaLabel || 'loading';
  const txtSvgTitle = svgTitle || txtAriaLabel;

  return (
    <div
      className={cn(
        'lds-loading-spinner',
        className
      )}
      style={{ width: dimSize, height: dimSize }}
      aria-label={decorative ? null : txtAriaLabel}
      aria-hidden={decorative ? 'true' : null}
      role={decorative ? null : 'alert'}
      aria-live={decorative ? null : 'assertive'}
      {...rest}
    >
      <svg
        className="lds-loading-spinner-svg"
        style={{
          width: dimSize,
          height: dimSize,
          animationDuration: durAnimationSpeed,
        }}
        viewBox="0 0 40 40"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>
          {txtSvgTitle}
        </title>
        <defs>
          <linearGradient
            id="loading-spinner-gradient-id"
            x1="0%"
            y1="0%"
            x2="0%"
            y2="100%"
          >
            <stop
              className="grad-stop-1"
              offset="10%"
            />
            <stop
              className="grad-stop-2"
              offset="90%"
            />
          </linearGradient>
        </defs>
        <path
          className="lds-loading-spinner-svg-circle"
          d="M20,40V36A16,16,0,1,1,36,20,16,16,0,0,1,20,36v4A20,20,0,1,0,0,20,20,20,0,0,0,20,40Z"
        />
        <circle
          className="lds-loading-spinner-svg-cap"
          cx="20.1"
          cy="38"
          r="2"
        />
        <path
          style={{ fill: 'url(#loading-spinner-gradient-id)' }}
          className="lds-loading-spinner-svg-tail"
          d="M20,0V4a16,16,0,0,1,0,32v4A20,20,0,0,0,20,0Z"
        />
      </svg>
    </div>
  );
}

export default LdsLoadingSpinner;

LdsLoadingSpinner.propTypes = {
  ariaLabel: PropTypes.string,
  animationSpeed: PropTypes.number,
  className: PropTypes.string,
  decorative: PropTypes.bool,
  size: PropTypes.number,
  svgTitle: PropTypes.string,
};
